<header *ngIf="showHeader"
        class="bh-desktop-header bg-white">
    <div class="d-flex align-items-center justify-content-between">
        <ion-img class="cursor-pointer"
                 src="assets/images/kotak-logo.svg"
                 alt="logo"
                 (click)="clickLogo()"></ion-img>

        <div class="d-flex align-items-center">
            <!-- <div class="nav-links">
                <a href="https://www.kotakmf.com/mutual-funds" class="link">Products</a>
                <a href="https://www.kotakmf.com/daily_newsletter" class="link">Market Outlook</a>
                <a href="https://www.kotakmf.com/fund-details" class="link">Fund Updates</a>
                <a href="https://www.kotakmf.com/sip" class="link">SIP</a>
                <a href="https://www.kotakmf.com/Information/investor-service" class="link">Investor Services</a>
            </div> -->
            <div class="bh-desktop-header-links d-flex align-items-center"
                 *ngIf="showHeader && userProfile && rightSectionToshow === 'user'">
                <!-- <button type="button" class="bg-white border-0 mx-4 position-relative">
                    <ion-img src="assets/images/header/notification-bing.svg" alt="notification"></ion-img>
                    <span class="header-notification-indicator position-absolute"></span>
                </button> -->
                <div class="bh-header-profile d-flex align-items-center mx-2">
                    <button type="button"
                            class="bg-white border-0 vert-middle">
                        <img (error)="onProfileImageError($event)"
                             src="{{ userProfile.profilePic || 'assets/icon/profile_img_on_error.svg' }}"
                             alt="profile"
                             (click)="routeToProfileorDashboard('profile')" />
                    </button>
                    <ion-text class="font-12 weight-400 d-block ms-2 cursor-pointer"
                              (click)="routeToProfileorDashboard('profile')">
                        Welcome back
                        <ion-text class="font-16 weight-600 d-block height-16"> {{ userProfile.name }} </ion-text>
                    </ion-text>
                </div>
                <!-- <button *ngIf="this.userProfile.type === 'IFA_USER' && this.userProfile.arnNo !== 'ARN-QK-TEAM'" (click)="navigateToPendingTransaction()" type="button" class="bg-white cursor-pointer border-0 position-relative mx-4">
                    <ion-img src="assets/images/header/timer.svg" alt="timer"></ion-img>
                    <span *ngIf="this.pendingTransaction !== '0'" class="header-timer-indicator position-absolute text-white weight-500">{{ this.pendingTransCount }}</span>
                </button> -->
                <button (click)="onLogOut()"
                        type="button"
                        class="bg-white border-0 header-logout ms-2">
                    <!-- <ion-text class="font-14 weight-400 d-block height-16 me-1" color="light"> Logout </ion-text> -->
                    <!-- <ion-img class="icon-15" src="assets/images/login/logout.svg" alt="logout"></ion-img> -->
                    <ion-icon name="log-out-outline"
                              class="secondary-color font-24"
                              alt="logout"></ion-icon>
                    <!-- <span class="header-notification-indicator position-absolute"></span> -->
                </button>
            </div>

            <div class=""
                 *ngIf="rightSectionToshow === 'loginbtn'">
                <div class="d-flex align-items-center">
                    <div class="w-10rem me-3">
                        <bh-button theme="light"
                                   (click)="goToEmpanelment('empanelment')">GET EMPANELLED</bh-button>
                    </div>
                    <!-- <div class="w-10rem me-3">
                        <bh-button theme="dark" (click)="goToTransaction()">TriggerTransaction</bh-button>
                    </div> -->
                    <div class="w-10rem">
                        <bh-button theme="dark"
                                   (click)="goToLoginRegister('register')">LOGIN/REGISTER</bh-button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</header>